import React, { useState, useEffect } from 'react'
import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ActivitieBudgetWidget from './ActivitieBudgetWidget'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import { saveSettingFormActivity } from '../../../redux/actions/subProjectFormSetting'
import notification from '../../../utils/notification'
import { CANCEL, DEFAULT_ERR_MSG, DELETE, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ActivitieSettingTimeWidget from './ActivitieSettingTimeWidget'
import { createDynamicListReq } from '../../../utils/dynamicListReq'
import { doneLoading, startLoading } from '../../../utils/loading'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ActivitieSettingFormWidget({
  schema,
  activity,
  activityIndex,
  onDelete = () => {},
  isSubmitAll,
  ...props
}) {
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  const [activitySchema, setActivitySchema] = useState(activity)
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  // useEffect(() => {
  //   setActivities(props.schema.activities || [])
  // }, [props.schema])

  useEffect(() => {
    if (isSubmitAll) {
      handleSubmit(onSubmit)
    }
  }, [isSubmitAll])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormActivity(formId, request)
      if (response) {
        setActivitySchema(response)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
        // scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let outcomes = createDynamicListReq(data.newObjects, data.newObjectsValuesName)

    let request = {
      id: activitySchema.id,
      activityName: data[formSchema.activityForm.activityName.name] || null,
      activityDetail: data[formSchema.activityForm.activityDetail.name] || null,
      outcomes: outcomes,
      activityTimes: data.activityTimeName || [],
      activityBudgetNote: data.activityBudgetNote || null,
    }
    console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  // console.log('errors : ', errors)

  return (
    <Panel
      //header={`กิจกรรมที่ ${activityIndex + 1}`}
      header={activitySchema.activityName || 'กิจกรรม'}
      collapsible
      defaultExpanded
      // shaded
      bordered
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      <div style={{ marginTop: -10 }}></div>
      {!isRefash && (
        <>
          <InputForm
            schema={formSchema.activityForm.activityName}
            // name={formSchema.activityForm.activityName.name + '_' + activityIndex}
            value={activitySchema.activityName}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />

          <CKEditorFrom
            schema={formSchema.activityForm.activityDetail}
            // name={formSchema.activityForm.activityDetail.name + '_' + activityIndex}
            value={activitySchema.activityDetail}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />

          <Panel
            style={{ marginTop: 20 }}
            header={'ผลลัพธ์/ผลผลิต'}
            collapsible
            defaultExpanded
            bordered
          >
            <div style={{ marginTop: -20, marginBottom: -30 }}>
              <SettingEditFormListWidget
                // schema={e.outcome}
                schema={formSchema.outcomeForm}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                setLoading={setIsLoading}
                datas={activitySchema.newOutcomes || []}
              />
            </div>
          </Panel>

          <ActivitieSettingTimeWidget
            schema={formSchema.activityTimeForm}
            items={activitySchema.activityTime || []}
            //header = ''
            refId={activitySchema.id}
            // resultName={`activityTimeName:${activitySchema.id}`}
            resultName={`activityTimeName`}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />

          <ActivitieBudgetWidget
            // schema={activitySchema.budget}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            dataList={activitySchema.budgets || []}
            budgetNote={activitySchema.activityBudgetNote}
            noteForm={formSchema?.activityBudgetForm?.activityBudgetNote}
          />
          <div className="right">
            <hr />
            {notiMsg && (
              <Message
                closable
                showIcon
                type={notiMsg.type}
                description={notiMsg.msg}
                onClose={() => setNotiMsg('')}
                style={{ marginBottom: 10 }}
              />
            )}
            <ViewButton
              style={{
                marginRight: 10,
                marginBottom: 10,
              }}
              onClick={() => {
                window.open(`${pathname.subProjectNew.proposal.activities}?preView`, '_blank')
              }}
              children={'แสดงตัวอย่าง'}
            />
            <SaveButton
              children={`${SAVE}กิจกรรมที่ ${activityIndex + 1}`}
              onClick={handleSubmit(onSubmit)}
            />
            <CancelButton
              icon="trash-o"
              children={`${DELETE}กิจกรรมที่ ${activityIndex + 1}`}
              onClick={() => {
                onDelete(activitySchema.id, activityIndex)
              }}
            />
            <CancelButton
              children={CANCEL}
              onClick={() => {
                setActivitySchema(activity)
                onRefash()
              }}
            />
          </div>
        </>
      )}

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
